<template>
    <div class="google-map-autocompleate">
        <vue-google-autocomplete
                class="map-google"
                ref="address"
                id="map"
                classname="form-control"
                :placeholder="placeholder"
                v-on:placechanged="getAddressData"
                @keyup="chengeCheck"
                country="ua"
        >
        </vue-google-autocomplete>
        <div v-show="showMap">
            <map-location @change-data="newData" :def-location="address"
                          :def-content="placeResultData"></map-location>
        </div>
    </div>
</template>

<script>
    import VueGoogleAutocomplete from 'vue-google-autocomplete';
    import MapLocation from "./MapLocation";
    import {gmapApi} from 'vue2-google-maps';

    export default {
        name: 'google-autocomplete',
        components: {MapLocation, VueGoogleAutocomplete},
        computed: {
            google: gmapApi
        },
        props: {
            refLatitude: {
                required: false,
            },
            refLongitude: {
                required: false,
            },
            refAddress: {
                required: false,
            },
            refCreate: {
                required: true,
            }
        },
        data: function () {
            return {
                address: {
                    street_number: '',
                    latitude: 0,
                    longitude: 0
                },
                flatError: false,
                addressError: false,
                flat: '',
                showMap: true,
                changed: false,
                placeholder: 'Введите адрес',
                isCheck: false,
                openNow: true,
                placeResultData: ''
            }
        },

        mounted() {
            let vm = this;
            if (this.refCreate == false) {
                setTimeout(() => {
                    vm.address.latitude = vm.refLatitude;
                    vm.address.longitude = vm.refLongitude;
                    vm.$refs.address.updateCoordinates({lat: vm.refLatitude, lng: vm.refLongitude});
                    vm.$refs.address.focus();
                    vm.$refs.address.update(this.refAddress);
                    vm.placeResultData = vm.refAddress;
                }, 1000);
            } else {
                setTimeout(() => {
                    vm.address.latitude = 47.834380;
                    vm.address.longitude = 35.132332;
                    vm.$refs.address.updateCoordinates({lat: 47.834380, lng: 35.132332});
                }, 1000);
            }
        },
        watch: {

            address: {
                handler: _.debounce(
                    function () {
                        this.changed = true;
                        this.sendAddress();
                    }, 100
                ),
                deep: true
            },


        },
        methods: {
            newData(data) {
                this.$refs.address.update(data.content);
                this.placeResultData = data.content;
                this.address.street_number = data.street_number;
                this.$refs.address.updateCoordinates(data.latlng);
                this.address.latitude = data.latlng.lat;
                this.address.longitude = data.latlng.lng;
                this.sendAddress();

            },
            geolocate() {
                var geocoder = new google.maps.Geocoder;
                let pos;
                let vm = this;
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };

                        geocoder.geocode({'location': pos}, function (results, status) {
                            if (status === 'OK') {
                                if (results[0]) {
                                    let street = undefined;
                                    if (results[0].address_components[0].types.indexOf('street_number') !== -1) {
                                        street = true;
                                    }
                                    vm.newData({
                                        latlng: pos,
                                        content: results[0].formatted_address,
                                        street_number: street
                                    });
                                    vm.placeResultData = results[0].formatted_address;

                                    vm.$forceUpdate();
                                } else {
                                    window.alert('No results found');
                                }
                            } else {
                                console.log(status);
                                window.alert('Geocoder failed due to: ' + status);
                            }
                        });
                    });
                }
            },

            chengeCheck() {
                this.isCheck = false;
            },
            /**
             * When the location found
             * @param {Object} addressData Data of the found location
             * @param {Object} placeResultData PlaceResult object
             * @param {String} id Input container ID
             */
            getAddressData: function (addressData, placeResultData, id) {
                this.address = addressData;
                console.log(placeResultData);
                let end_address = '';
                placeResultData.address_components.forEach((item) => {
                    end_address = end_address + item.long_name + ', ';
                });
                // this.placeResultData = placeResultData.formatted_address;
                this.placeResultData = end_address;
                console.log(this.placeResultData);
            },
            sendAddress: function () {
                this.$emit('update', {
                    'address': JSON.stringify((this.address)),
                    'flat': this.flat,
                    'formatted_address': this.placeResultData,
                    'lat': this.address.latitude,
                    'lng': this.address.longitude,
                    'check': this.isCheck,
                });
                // }
            },
            save() {
                this.flatError = false;

                let formData = new FormData();
                formData.append('address', JSON.stringify(this.address));
                formData.append('flat', this.flat);
                formData.append('formatted_address', this.placeResultData);


            },
            saveClass() {
                if (this.changed) {
                    return 'save-map changed-map';
                } else {
                    return 'save-map';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/GoogleAutocomplete.vue